// src/pages/OrganizerRegisterPage.tsx
import React from "react";
import OrganizerRegisterForm from "../components/Organizer/Register/OrganizerRegisterForm";
import { usePageTitle } from "../hooks/usePageTitle";

const OrganizerRegisterPage: React.FC = () => {
	usePageTitle("主催者登録");

	return (
		<div className="min-h-screen bg-gray-50 dark:bg-gray-900 py-8">
			<OrganizerRegisterForm />
		</div>
	);
};

export default OrganizerRegisterPage;
